import {store} from "../store/configureStore";
import {actions, IToken} from "../store/sliceToken";
import {actions as actionsUser, IUser} from "../store/sliceUser";
import {IResponse, requestBase, requestWithToken} from "./RequestBase";
import moment from "moment/moment";
import {config} from "../config";
import {actions as actionsFile, IFile} from "../store/sliceFiles";
import {actions as modal} from "../store/sliceModal";

export interface ITokenRequest {
    grant_type: string | null;
    username: string | null;
    password: string | null;
    token: string | null;
    verification_code: string | null;
}

export interface ITokenResponse {
    access_token: string | null;
    token_type: string | null;
    expire: number | null;
    refresh_token: string | null;
    verification: string | null;
}

let tokenPromise: IResponse | PromiseLike<IResponse> | null = null;
export const fetchToken = async (request: ITokenRequest, isLoading: boolean = true, isRefresh: boolean = true): Promise<IResponse> => {
    if (tokenPromise) {
        return tokenPromise;
    }
    const data: IResponse = await requestBase(`${config.authUrl}/api/auth/token`,
        {
            method: "POST",
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: `grant_type=${request.grant_type}&username=${request.username}&password=${request.password}&token=${request.token}&verification_code=${request.verification_code}`,
        },
        false,
        isLoading
    );
    tokenPromise = data;
    if (data.status) {
        tokenPromise = null;
    }

    if (data?.status === 200) {
        const token: ITokenResponse = data.data;

        const saveToken: IToken = {...token, expire: moment().add(token.expire, 'second').toDate().toISOString()}

        store.dispatch(actions.saveToken(saveToken))
    } else if (data.status === 401) {
        if (isRefresh) {
            let token: IToken = store.getState().token;
            alert("AuthRequest.fetchToken isRefresh = true Обнуление и на окно авторизации " + request.grant_type)
            return await fetchToken({
                grant_type: 'refresh_token',
                token: token.refresh_token,
            } as ITokenRequest, isLoading, false)
        } else {
            alert("AuthRequest.fetchToken Обнуление и на окно авторизации " + request.grant_type)
            window.location.replace(`${config.uiStart}/auth`)
            store.dispatch(actions.clear())
        }
    }
    return data;
}

export async function fetchRefreshToken(): Promise<IToken> {

    let token: IToken = store.getState().token;
    if (!token?.refresh_token) {
        alert("AuthRequest.fetchRefreshToken Обнуление и на окно авторизации")
        store.dispatch(actions.clear())
        window.location.replace(`${config.uiStart}/auth`)
    }
    if (moment().isAfter(token.expire)) {
        await fetchToken({
            grant_type: 'refresh_token',
            token: token.refresh_token,
        } as ITokenRequest)

        return token = store.getState().token;
    }

    return token
}


export interface IRegistration {
    name: string | null;
    login: string | null;
    password: string | null;
    email: string | null;
}

export const fetchRegistration = async (registration: IRegistration): Promise<IResponse> => {
    const data: IResponse = await requestBase(`${config.authUrl}/api/auth/registration`,
        {
            method: "POST",
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: `name=${registration.name}&login=${registration.login}&password=${registration.password}&email=${registration.email}`,
        }
    );

    if (data?.status === 200) {
        const token: ITokenResponse = data.data;

        const saveToken: IToken = {...token, expire: moment().add(token.expire, 'second').toDate().toISOString()}
        store.dispatch(actions.saveToken(saveToken))
    }
    return data;
}


export const fetchUser = async (): Promise<IResponse> => {
    const data: IResponse = await requestWithToken(`${config.authUrl}/api/user/`,
        {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
            },
        }
    );

    if (data?.status === 200) {
        const user: IUser = data.data;
        store.dispatch(actionsUser.setUser(user))
    } if (data?.status === 401) {
        let token: IToken = store.getState().token;
        let resp = await fetchToken({
            grant_type: 'refresh_token',
            token: token.refresh_token,
        } as ITokenRequest)
        if (resp.isSuccess) {
            return fetchUser()
        } else {
            alert("AuthRequest.fetchUser на окно авторизации")
            window.location.replace(`${config.uiStart}/auth`)
        }
    }
    return data;
}

